module.exports = __webpack_public_path__ + "static/media/clem-onojeghuo.f8f6718a.jpg";